import { render, staticRenderFns } from "./AllowancesPlanDetailsAdd.vue?vue&type=template&id=55e13aab&scoped=true&"
import script from "./AllowancesPlanDetailsAdd.vue?vue&type=script&lang=js&"
export * from "./AllowancesPlanDetailsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e13aab",
  null
  
)

export default component.exports